import PieChart from '../components/pie/pie.vue';
import BarChart from '../components/bar/bar.vue';
import MapChart from '../components/map/map.vue';
import LineChart from '../components/line/line.vue';
import mapData from './mapData.js';

export default {
  name: "cdyIndex",

  components: {
    PieChart,
    BarChart,
    MapChart,
    LineChart,
  },

  data() {
    return {
      selleftPanel4: 0,
      selleftPanel3: 0,
      progress: true,
      mapData,
      imgarr: [
        {
          url: "https://nfs.nxin.com/cms_image_859135d1-3a71-41c6-b49a-dd707a4a4cb9.png",
          show: true,
          name: "园区分布",
        },
        {
          url: "https://nfs.nxin.com/cms_image_cac7a52c-c18c-49ab-9f27-2a00002863d3.png",
          show: true,
          name: "草数据",
        },
        {
          url: "https://nfs.nxin.com/cms_image_edd6ff90-7722-4235-84b8-adbeaa48d5c8.png",
          show: true,
          name: "牛数据",
        },
        {
          url: "https://nfs.nxin.com/cms_image_70c271ea-bedb-4be1-a334-a093e29bd814.png",
          show: true,
          name: "马数据",
        },
        {
          url: "https://nfs.nxin.com/cms_image_4dd293cc-f816-4f5e-b497-7c4ba924bec8.png",
          show: true,
          name: "羊数据",
        },
      ],
      rightPanel1: {
        data: [
          { value: 5938, name: "猪肉" },
          { value: 2837, name: "禽肉" },
          { value: 801, name: "牛肉" },
          { value: 496, name: "羊肉" },
          // { value: 384, name: "其他" },
        ],
        color: ["#33a7ff", "#5c17e6", "#b800ff", "#ff66e5"],
        unit: "万吨",
        radius: ["47%", "80%"],
      },
      leftPanel1: {
        data: [
          { value: 1048, name: "2015" },
          { value: 735, name: "2014" },
          { value: 580, name: "2013" },
          { value: 484, name: "2010" },
        ],
        unit: "吨",
        color: ["#33a7ff", "#5c17e5", "#b800ff", "#ff66e5"],
        title: "产量",
      },
      leftPanel1s: {
        data: [
          { value: 1048, name: "2015" },
          { value: 735, name: "2014" },
          { value: 580, name: "2013" },
          { value: 484, name: "2010" },
        ],
        unit: "万亩",
        color: ["#33a7ff", "#5c17e5", "#b800ff", "#ff66e5"],
        title: "面积",
      },
      leftPanel2: {
        series: [
          {
            name: "期末",
            value: [ 9038.75, 8915.28, 9138.27, 9562.06, 9817.25, 10817.25, 11817.25],
            show: true,
            unit: "头",
            colors: 0,
          },
          {
            name: "出栏",
            value: [4340, 4397, 4534, 4565, 4707, 4907, 4307],
            show: true,
            unit: "头",
            colors: 1,
          },
        ],
        category: ["2019年", "2020年", "2021年", "2022年", "2023年","2024年","2025年"],
      },
      leftPanel5: {
        series: [
          {
            name: "产量",
            value: [616.89, 616.91, 634.62, 644.06, 667.28, 672, 698, 682, 692],
            show: true,
            unit: "万吨",
            colors: 0,
          },
          {
            name: "消费量",
            value: [663.8, 673.48, 704.04, 747.96, 833.93, 930.02, 1000, 1030.02, 1130.02],
            show: true,
            unit: "万吨",
            colors: 1,
          },
        ],
        category: ["2017年", "2018年", "2019年", "2020年", "2021年", "2022年", "2023年","2024年","2025年"],
      },
      leftPanel6: {
        series: [
          {
            name: "产量",
            value: [439.9, 460.25, 471.07, 475.07, 487.52, 492, 514, 562,483],
            show: true,
            unit: "万吨",
            colors: 0,
          },
          {
            name: "消费量",
            value: [461.85, 481.85, 495.45, 506.64, 526.57, 528.53, 554.9, 212,234],
            show: true,
            unit: "万吨",
            colors: 1,
          },
        ],
        category: ["2017年", "2018年", "2019年", "2020年", "2021年", "2022年", "2023年","2024年","2025年"],
      },
      leftPanel3: {
        series: [
          {
            name: "牛",
            show: true,
            colors: 0,
            value: [4211.44, 4264.95, 4340.26, 4397.48, 4534, 4564, 410.3, 147, 1847],
          },
          {
            name: "马",
            show: true,
            colors: 1,
            value: [397.5, 87.7, 30789, 31011, 31699, 31941, 33045, 13874, 13874],
          },
          {
            name: "羊",
            show: true,
            colors: 2,
            value: [411.44, 264.95, 340.26, 439.48, 454, 564, 410.3, 347, 437],
          },
        ],
        category: ["2017", "2018", "2019", "2020", "2021", "2022", "2023","2024","2025"],
      },
      leftPanel4: {
        series: [
          {
            name: "牛",
            show: true,
            colors: 0,
            value: [30005, 30798, 31011, 31699, 31941, 33045, 41941, 46045, 48045],
          },
          {
            name: "羊",
            show: true,
            colors: 1,
            value: [4265, 4340.3, 4397.5, 4533.9, 4565, 4707, 6565, 5707, 6007],
          },
        ],
        category: ["2017", "2018", "2019", "2020", "2021", "2022", "2023","2024","2025"],
      },
      rightPanel2: {
        series: [
          {
            name: "牛",
            value: [150, 230, 224, 218, 135, 147],
          },
          {
            name: "马",
            value: [100, 150, 104, 218, 215, 237],
          },
          {
            name: "羊",
            value: [120, 250, 204, 118, 115, 137],
          },
        ],
        category: ["2015", "2016", "2017", "2018", "2019", "2020"],
      },
      rightPanel3: {
        series: [
          {
            name: "平台覆盖牛源量趋势",
            value: [150, 230, 224, 218, 135, 147, 150, 230, 224, 218, 135, 147],
          },
        ],
        category: [
          ["01", "2025"],
          ["02", "2025"],
          ["03", "2025"],
          ["04", "2025"],
          ["05", "2025"],
          ["06", "2025"],
          ["07", "2025"],
          ["08", "2025"],
          ["09", "2025"],
          ["10", "2025"],
          ["11", "2025"],
          ["12", "2015"],
        ],
      },
      rightPanel4: [0, 0, 0, 0],
    };
  },

  mounted() {
    this.rightPanel4 = [61, 19, 12, 10];

    setInterval(() => {
      this.progress = false;
      this.rightPanel4 = [0, 0, 0, 0];
      setTimeout(() => {
        this.progress = true;
        this.rightPanel4 = [61, 19, 12, 10];
      }, 300);
    }, 8000);
  },
  methods: {
    leftPanel4Click(index) {
      this.selleftPanel4 = index;
    },
    leftPanel3Click(index) {
      this.selleftPanel3 = index;
    },
    imgarrCLick(item) {
      item.show = !item.show;
    },
  },
};
